import React, { useCallback } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { SmallPortalTooltip } from './Tooltip';
import { TooltipDetail, TooltipTitle } from './Admin/Progress/Tooltip';

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
`;

const Link = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  background: none;
  border: none;
  padding: 0;
  cursor: copy;
  transition: all 0.3s ease-in-out;
`;

interface CopyLinkProps {
  link: string;
  children?: React.ReactNode;
  successMessage?: string;
}

export default function CopyLink({
  link,
  children,
  successMessage = 'Link copied to clipboard!',
}: CopyLinkProps) {
  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(link);
    toast.success(`✔ ${successMessage}`);
  }, [link, successMessage]);

  return (
    <Wrapper>
      <Link
        onClick={handleCopy}
        type="button"
        data-tooltip-id={`copy-link-${link}`}
      >
        {children || link}
      </Link>
      <SmallPortalTooltip
        anchorSelect={`[data-tooltip-id="copy-link-${link}"]`}
      >
        <TooltipTitle>Click to copy to clipboard</TooltipTitle>
        <TooltipDetail>{link}</TooltipDetail>
      </SmallPortalTooltip>
    </Wrapper>
  );
}
